import { getters } from "@/constants/state";

export default {
  [getters.INPUTNOTE_GETTER]: (state) => state.inputNotes,
};
